import { FormLabel, FormLabelProps } from "@mui/material";

export function Label(props: FormLabelProps) {
  return <FormLabel {...props} />;
}
